var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208.966,
    height: 55.683,
    viewBox: "0 0 208.966 55.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.799,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#295fa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2197c6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1010.132 -157.022)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1010.132 157.022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.178,0a21.278,21.278,0,0,1-3.012,3.781A21.087,21.087,0,0,1,25.227,9.973,21.087,21.087,0,0,1,10.288,3.781,21.19,21.19,0,0,1,7.278,0H0A27.222,27.222,0,0,0,1.713,3.246,27.67,27.67,0,0,0,5.734,8.334a27.511,27.511,0,0,0,19.493,8.081A27.51,27.51,0,0,0,44.72,8.334a27.674,27.674,0,0,0,4.021-5.088A27.234,27.234,0,0,0,50.454,0Z",
    transform: "translate(2.366 38.768)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.21,32.326a21.148,21.148,0,0,0-5.66-19.672l-10.4,10.4-4.554,4.554-4.555-4.554-10.4-10.4a21.148,21.148,0,0,0-5.66,19.672H.406A27.657,27.657,0,0,1,13.169,4.076L17.893,8.8l9.7,9.7,9.7-9.7,4.725-4.725A27.9,27.9,0,0,1,47.1,8.1a27.588,27.588,0,0,1,7.675,24.226ZM27.593,6.442a21.263,21.263,0,0,0-3.429.277l-5.3-5.3a27.613,27.613,0,0,1,17.464,0l-5.3,5.3A21.256,21.256,0,0,0,27.593,6.442Z",
    transform: "translate(0 0)",
    fill: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1073.19 168.023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.95,33.186V28.563h1.779c2.479,0,3.122-.659,4.29-3.534l.073-.155-8.057-17.56h5.6l5.073,11.7,4.736-11.7h5.467L137.62,26.079c-2.279,5.154-4.284,7.107-8.551,7.107Zm-45.852,0V7.315h3.4l.878,1.729a9.077,9.077,0,0,1,6.094-2.267,9.735,9.735,0,0,1,9.962,10.045A9.763,9.763,0,0,1,91.471,26.9a9.111,9.111,0,0,1-5.231-1.6v7.889Zm4.77-16.363a5.18,5.18,0,1,0,10.36,0,5.18,5.18,0,1,0-10.36,0Zm16.942-.028a9.744,9.744,0,0,1,9.975-10.017A9.271,9.271,0,0,1,119.032,9.1l.55-1.818h3.837V26.3h-4.03l-.442-1.7a9.246,9.246,0,0,1-6.163,2.269A9.778,9.778,0,0,1,102.809,16.795Zm5.211,0a5.18,5.18,0,1,0,10.36,0,5.18,5.18,0,1,0-10.36,0ZM30.307,18.3V7.315h5.141v10.4c0,2.705,1.431,4.318,3.806,4.318s3.778-1.648,3.778-4.318V7.315h5.141V18.3c0,5.135-3.541,8.567-8.919,8.567S30.307,23.438,30.307,18.3Zm43.185,8.029V7.315h5.142V26.332Zm-6.1,0c-4.183,0-6.755-2.571-6.755-6.79V11.449H57.194V10.338L64.7,2.353h.983V7.315h5.248v4.134h-5.16V18.86A2.646,2.646,0,0,0,68.7,21.754h2.337v4.578Zm-17,0V.462h5.141v25.87Zm-27.2,0V15.255c0-2.539-1-3.877-2.859-3.877-2.3,0-3.657,1.69-3.657,4.667V26.332H11.664V15.255c0-2.539-.967-3.877-2.808-3.877-2.325,0-3.714,1.69-3.714,4.667V26.332H0V7.315H3.593l.963,2.358a7.313,7.313,0,0,1,5.672-2.809,6.164,6.164,0,0,1,5.521,3.043,7.192,7.192,0,0,1,5.887-3.043c3.934,0,6.7,3.086,6.7,7.543V26.332ZM73.5,4.78V0h5.122V4.78Z",
    transform: "translate(0 0)",
    fill: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredLogo);
export default __webpack_public_path__ + "static/media/colored-logo.a87a6b49206b79532ec18313992eb410.svg";
export { ForwardRef as ReactComponent };